// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import less from 'less'
import './assets/font/iconfont.css'
import store from './store/index.js'
import http from './js/request.js'
import api from './js/api.js'
import util from './js/util.js'
import axios from 'axios'
import Clipboard from 'clipboard'

import Video from 'video.js'
import  "vue-video-player/src/custom-theme.css";
import 'video.js/dist/video-js.css'
Vue.prototype.$video = Video

console.log(process.env);
Vue.use(less);

import Header from './components/common/header.vue'
import ULink from './components/common/ulink.vue'
import Vant from 'vant';
import 'vant/lib/index.css';

Vue.prototype.$http = http
Vue.prototype.$axios = axios
Vue.prototype.$api = api
Vue.prototype.$util = util

Vue.prototype.Clipboard = Clipboard
Vue.use(Vant);
Vue.component('Header',Header)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,//新加的
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js